import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import classes from './deleteConfirmationModalDrugReferenceByNDC.module.scss';

interface DeleteConfirmationModalDrugReferenceFgNdcProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModalDrugReferenceFgNdc = ({
  visible,
  onHide,
  onConfirm
}: DeleteConfirmationModalDrugReferenceFgNdcProps) => {
  return (
    <Dialog
      header="Delete This Drug Reference?"
      visible={visible}
      onHide={onHide}
      className={classes.modal}
      style={{ width: '450px' }}
    >
      <p>Are you sure you want to delete this drug reference? This action cannot be undone.</p>

      <div className={classes.modalFooter}>
        <Button label="Cancel" className="p-button-text" onClick={onHide} />
        <Button label="Yes, Delete" className={classes.confirmButton} onClick={onConfirm} />
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModalDrugReferenceFgNdc;
